import axios from "axios";

class HansongModel {
    constructor(config) {
        this.apiUrl = config.apiUrl;
        this.objects = {}
    }

    send(path, method, body) {
        const message = {
            path: path,
            method: method,
            payload: body
        };

        return axios.post(this.apiUrl+"hansong",JSON.stringify(message))
    }
}

export default HansongModel